import { UniFiCategoryId, UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/WiFi/u7-pr-xgs@2x.jpg";
import v3Image from "../../assets/Flagship/u7-pro-xgs.jpg";
import { type Product } from "../../types";
import { wifiFlagship } from "../product-list-groups/wifi-flagship";
import {
  connectedDevices,
  dimensions,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiTechnology,
} from "../properties";

export const u7proXgs: Product = {
  id: "u7proXgs",
  productTitle: "U7 Pro XGS",
  description: "u7proXgs.description",
  storePathParts: {
    category: UniFiChildCategorySlug.WiFiFlagship,
    productSlug: "u7-pro-xgs",
  },
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.WiFi}/u7-pro-xgs`,
  ],
  productListGroup: wifiFlagship,
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 205,
    height: 182,
  },
  isNew: true,
  propertyValues: [
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: "u7proXgs.dimensions",
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u7proXgs.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "160 m² (1,750 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: {
        type: "string",
        value: "500+",
      },
    },
    {
      propertyId: "powerMethodPoe",
      value: {
        type: "string",
        value: "PoE++",
      },
    },
    {
      propertyId: uplink.id,
      value: {
        type: "string",
        value: "10/5/2.5/1 GbE",
      },
    },
    {
      propertyId: "radios",
      value: {
        type: "boolean",
        value: true,
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "wifiMounting",
      value: {
        type: "translation",
        value: "commons.mounting.ceilingWall",
      },
    },
  ],
};
